import React from "react";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import styles from "./styles.module.scss";

export default function UnitItem({icon = '', label, value, customStyles}) {
  return (
    <div className={styles.item}>
      <div className={styles.label}>
        <img src={toAbsoluteUrl(icon)} alt="icon"/>
        <span className={styles.labelText}>{label}</span>
      </div>
      <div
        className={styles.value}
        title={typeof value === 'string' ? value : ''}
        style={customStyles}
      >{value}</div>
    </div>
  );
}